import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import Modal from './ModalInstaller';



export { Modal,  ModalHeader,  ModalBody, ModalFooter };
